import moment from 'moment';
import React from 'react';

type Props = {
  value: string | Date;
  template?: 'condensed' | 'full' | 'LL h:mm a' | 'MMM D';
};
export default function DateFormatter({ value, template }: Props): JSX.Element {
  const v = moment(value);

  if (typeof template !== 'string') {
    if (v.isBefore(new Date())) {
      return <>{v.fromNow(true)} ago</>;
    }
    return <>{v.fromNow(true)} from now</>;
  }

  if (template === 'condensed') {
    if (v.isSame(new Date(), 'day')) {
      return <>{v.format('h:mm a')}</>;
    }
    if (v.isSame(new Date(), 'week')) {
      return <>{v.format('ddd')}</>;
    }
    if (v.isSame(new Date(), 'year')) {
      return <>{v.format('MMM D')}</>;
    }
    return <>{v.format('MMM D, YYYY')}</>;
  }

  if (template === 'full') {
    return <>{v.format('ll h:mm:ss a')}</>;
  }

  return <>{v.format(template)}</>;
}
